import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

export const TableHeader = (
  labelValue,
  getTextField,
  thClick,
  textField,
  order
) => {
  return (
    <div
      style={{ cursor: "pointer" }}
      onClick={(e) => thClick(e, getTextField)}
    >
      {labelValue}
      {textField === getTextField ? (
        order === "asc" ? (
          <ArrowDropDownIcon />
        ) : (
          <ArrowDropUpIcon />
        )
      ) : (
        " "
      )}
    </div>
  );
};
